import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ListModeComponent } from './list-mode.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        InputsModule,
        CommonModule,
        FormsModule,
        TranslateModule
    ],
    declarations: [
        ListModeComponent
    ],
    exports: [
        ListModeComponent
    ]
})
export class ListModeModule { }
